<template>
  <div v-if="total > 0" :class="$style.page">
    <!-- 上一页 -->
    <button :disabled="currentPage === 1" @click="onPrev">&lt;</button>

    <!-- 第一页 -->
    <button
      :disabled="currentPage === 1"
      :class="currentPage === 1 && $style.current"
      @click="onChange(1)"
    >
      1
    </button>

    <!-- before ... -->
    <button v-if="currentPage > 4" disabled>···</button>

    <!-- 中间页 -->
    <button
      v-for="i in pageRange"
      :key="i"
      :disabled="i === currentPage"
      :class="i === currentPage && $style.current"
      @click="onChange(i)"
    >
      {{ i }}
    </button>

    <!-- after ... -->
    <button v-if="pageCount > 9 && currentPage < pageCount - 3" disabled>
      ···
    </button>

    <!-- 最后一页 -->
    <button
      :disabled="currentPage === pageCount"
      :class="currentPage === pageCount && $style.current"
      @click="onChange(pageCount)"
    >
      {{ pageCount }}
    </button>

    <!-- 下一页 -->
    <button :disabled="currentPage === pageCount" @click="onNext">
      &gt;
    </button>
  </div>
</template>

<script>
export default {
  props: {
    total: { type: Number, default: 0 }, // 总条目数
    pageSize: { type: Number, default: 0 }, // 每页显示条目个数
    currentPage: { type: Number, default: 0 }, // 当前页数
  },
  computed: {
    // 总页数
    pageCount() {
      if (this.total && this.pageSize) {
        return Math.ceil(this.total / this.pageSize)
      } else {
        return 0
      }
    },

    // 中间页范围
    pageRange() {
      const range = []

      // 当前位置偏向
      // before - 1 after - 2 other - 0
      const position =
        this.currentPage < 5 ? 1 : this.currentPage > this.pageCount - 4 ? 2 : 0

      // 中间页开始值
      const start =
        position === 1
          ? 2
          : position === 2
          ? this.pageCount - 6
          : this.currentPage - 2

      // 中间页数量
      const count = position === 0 ? 5 : 6

      for (let i = 0; i < count; i += 1) {
        range.push(i + start)
      }
      return range
    },
  },
  methods: {
    onPrev() {
      this.$emit('change', this.currentPage - 1)
    },
    onNext() {
      this.$emit('change', this.currentPage + 1)
    },
    onChange(i) {
      this.$emit('change', i)
    },
  },
}
</script>

<style lang="less" module>
@border-color: #ddd;
@background-color: #fff;
@color: #aaa;
@hover-border-color: #a0a0a0;
@hover-color: #696969;
@active-border-color: @primary;
@active-background-color: @primary;
@active-color: #fff;

.page {
  display: flex;
  justify-content: center;
  margin-top: 4em;
  font-size: 12px;
  color: @color;
  text-align: center;

  button {
    .size(24px);
    margin: 0 0.2em;
    border: 1px solid @border-color;
    border-radius: 2px;
    background-color: @background-color;

    &:hover:not([disabled]) {
      border-color: @hover-border-color;
      color: @hover-color;
    }

    &[disabled]:not(.current) {
      opacity: 0.5;
    }
  }

  .current {
    border-color: @active-border-color;
    background-color: @active-background-color;
    color: @active-color;
  }
}
</style>
